// extracted by mini-css-extract-plugin
module.exports = {"hoverPanel":"_2lqvR","editBtn":"MfLtI","previewBtn":"_1M9QM","showInfo":"_1-Mko"};